import {Controller} from 'stimulus';

export default class extends Controller {

  static targets = ['totop'];

  connect() {

  }

  onScroll(event) {
    const v = window.scrollY;
    if(v > 300) {
      document.body.classList.add('scrolled');
    }
    if(v <= 300) {
      document.body.classList.remove('scrolled');
    }
  }

  hrefclick(e) {
    e.preventDefault();
    let link = e.target;

    var tw = link.closest(".team-wrap");

    console.log(tw);
    var reffer = tw.getAttribute('data-href');
    if(reffer) {
      document.location = reffer;
    }
  }
}

